import React, {ChangeEvent, Component, FormEvent} from 'react';
import magnifier from "../../assets/magnifier.svg";
import "./text_search_filter.scss";

const SVG_ID = "#svg_id";

interface TextSearchFilterProps {
    placeholder: string;
    value?: string;
    continuous?: boolean;

    searchUpdated: (text: string) => void;
}

class TextSearchFilter extends Component<TextSearchFilterProps> {

    state: {
        value: string
    };

    constructor(props: TextSearchFilterProps) {
        super(props);

        this.state = {
            value: this.props.value ? this.props.value : ""
        };
    }

    componentDidUpdate(prevProps: Readonly<TextSearchFilterProps>, prevState: Readonly<{}>, snapshot?: any): void {
        if (this.props.value !== prevProps.value) {
            this.setState({
                value: this.props.value
            });
        }
    }

    onChange = (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({value: e.target.value}, () => {
            if (this.props.continuous) {
                this.props.searchUpdated(this.state.value)
            }
        });
    };

    searchUpdated = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        this.props.searchUpdated(this.state.value);
    };

    render() {
        return (
            <form onSubmit={this.searchUpdated} name="searchForm" className="text-search-filter">
                <button type="submit">
                    <svg className="magnifier">
                        <use xlinkHref={`${magnifier}${SVG_ID}`}/>
                    </svg>
                </button>
                <input name="search" key="search-input" className="search-input" type="text"
                       onChange={this.onChange}
                       value={this.state.value} placeholder={this.props.placeholder} />
            </form>
        );
    }
}

export default TextSearchFilter;
